import {
  CircularSpinnerß,
  DialogContent,
  Dialogß,
  type DialogßProps,
} from '@otter-ai/den-components';

/**
 * A modal with a spinner for the contents.
 * Use this when waiting to fetch the modal component to show.
 */
export function LoadingModal({
  size = 'sm',
  isOpen = true,
  title,
  Header,
  ...props
}: Omit<DialogßProps, 'children' | 'data-testid'>) {
  const headerProps =
    !title && !Header ? { Header: <span /> } : { title, Header };

  return (
    <Dialogß
      size={size}
      isOpen={isOpen}
      {...props}
      {...headerProps}
      data-testid="loading-modal"
    >
      <DialogContent>
        <LoadingModalContent />
      </DialogContent>
    </Dialogß>
  );
}

export function LoadingModalContent() {
  return (
    <div
      data-testid="loading-modal-content"
      className="flex justify-center items-center min-h-[min(200px,50vh)]"
    >
      <CircularSpinnerß data-testid="loading-modal-spinner" size="xlg" />
    </div>
  );
}
